import Phaser from 'phaser';
import TextureKeys from '~/consts/TextureKeys';
export default class CardImage extends Phaser.GameObjects.Sprite
{
    public xpos: number;
    public ypos: number;
    private isFaceUp: boolean;
    public cardImage:string
    public myScale!: number;
    constructor( scene: Phaser.Scene, x: number, y: number, xpos: number, ypos: number,img:string,mainCardimage:string)
    {
        super(scene,x,y,img)
        scene.add.existing(this);
        this.xpos = xpos;
        this.ypos = ypos;
        this.cardImage=mainCardimage
        this.isFaceUp=false;
    }
    setCard(name : string)
    {
        this.setTexture(name);
    }

    foldCard(fast:boolean=false) {
        this.myScale=this.scale
        if (this.isFaceUp) return;

        this.scene.tweens.add({
            targets: this,
            scaleX: 0,
            duration: (fast)?50:100,
            ease: 'Linear',
            onComplete: () => {
                this.setTexture(TextureKeys.Cards,this.cardImage);
                this.scene.tweens.add({
                    targets: this,
                    scaleX: this.myScale,
                    duration: (fast)?50:100,
                    ease: 'Linear'
                });
            }
        });

        this.isFaceUp = true;
    }
}